<ng-container *ngIf="value[0]">
    <avatar big
            #triggerOverlay="cdkOverlayOrigin"
            cdkOverlayOrigin
            [userId]="value[0]"
            (mouseenter)="showStaffTooltip([value[0]])"
            (mouseleave)="onMouseOut($event)"
            class="st-staff-id-list-value">
        {{getItemInitials(value[0])}}
    </avatar>
    <ng-template cdkConnectedOverlay
                 [cdkConnectedOverlayOrigin]="triggerOverlay"
                 [cdkConnectedOverlayOpen]="isListOpen"
                 (attach)="panelAttached()">
        <staff-id-list-tooltip [users]="tooltipUsers">
        </staff-id-list-tooltip>
    </ng-template>
</ng-container>
<ng-container *ngIf="value[1]">
    <avatar big
            #triggerOverlay="cdkOverlayOrigin"
            cdkOverlayOrigin
            [userId]="value[1]"
            (mouseenter)="showStaffTooltip([value[1]])"
            (mouseleave)="onMouseOut($event)"
            class="st-staff-id-list-value">
        {{getItemInitials(value[1])}}
    </avatar>
</ng-container>
<ng-container *ngIf="value[2]">
    <avatar big
            #triggerOverlay="cdkOverlayOrigin"
            cdkOverlayOrigin
            (mouseenter)="showStaffTooltip([value[2]])"
            (mouseleave)="onMouseOut($event)"
            [userId]="value[2]"
            class="st-staff-id-list-value">
        {{getItemInitials(value[2])}}
    </avatar>
</ng-container>
<ng-container *ngIf="value[3]">
    <avatar big
            #triggerOverlay="cdkOverlayOrigin"
            cdkOverlayOrigin
            (mouseenter)="showStaffTooltip([value[3]])"
            (mouseleave)="onMouseOut($event)"
            [userId]="value[3]"
            class="st-staff-id-list-value">
        {{getItemInitials(value[3])}}
    </avatar>
</ng-container>
<ng-container *ngIf="shouldShowExtraStaff; else noExtraStaff">
    <div class="st-staff-id-list-value"
         #triggerOverlay="cdkOverlayOrigin"
         cdkOverlayOrigin
         (mouseenter)="showStaffTooltip(value)"
         (mouseleave)="onMouseOut($event)">
        +{{extraStaffCount}}
    </div>
</ng-container>
<ng-template #noExtraStaff>
    <ng-container *ngIf="value[4]">
        <avatar big
                [userId]="value[4]"
                #triggerOverlay="cdkOverlayOrigin"
                cdkOverlayOrigin
                (mouseenter)="showStaffTooltip([value[4]])"
                (mouseleave)="onMouseOut($event)"
                class="st-staff-id-list-value">
            {{getItemInitials(value[4])}}
        </avatar>
    </ng-container>
</ng-template>

<button mat-button
        class="st-staff-id-list-button-add"
        (menuClosed)="valueChanged()"
        (menuOpened)="onMenuOpened()"
        [matMenuTriggerFor]="listDropDownMenu"
        [disabled]="disabled"
        *ngIf="shouldShowAddButton"
        [class.st-staff-id-list-button-add-valid]="(required && value && value?.length === 0) || !value"
        [class.st-staff-id-list-button-add-required]="required">
    <mat-icon>
        add
    </mat-icon>
    {{label}}
</button>

<mat-menu #listDropDownMenu="matMenu"
          class="st-staff-id-list-menu">
    <mat-chip-grid #chipGrid
                   click-stop-propagation>
        <mat-chip-row *ngFor="let user of value"
                      (removed)="remove(user)"
                      matChip>
            <avatar small
                    [userId]="user"
                    matChipAvatar></avatar>
            {{getName(user)}}
            <button matChipRemove>
                <mat-icon>close</mat-icon>
            </button>
        </mat-chip-row>
    </mat-chip-grid>
    <form click-stop-propagation
          [dir]="dir">
        <mat-form-field appearance="fill"
                        subscriptSizing="dynamic"
                        class="st-staff-id-list-form-field">
            <mat-icon matPrefix>search</mat-icon>
            <input #searchBox
                   type="text"
                   matInput
                   [placeholder]="searchLabel"
                   [matChipInputFor]="chipGrid"
                   [formControl]="staffFilter"
                   (matChipInputTokenEnd)="add($event)">
        </mat-form-field>
        <mat-selection-list [multiple]="false"
                            hideSingleSelectionIndicator
                            [ngModel]="value"
                            click-stop-propagation
                            (selectionChange)="selected($event)">
            <mat-list-option *ngFor="let userId of  filteredOptions | async"
                             class="st-staff-id-list-menu-option"
                             [value]="userId">
                <div class="st-staff-id-list-menu-option-info">
                    <avatar class="st-staff-id-list-menu-option-info-avatar"
                            big
                            [userId]="userId">
                    </avatar>
                    <div class="st-staff-id-list-menu-option-info-labels">
                        <span class="st-staff-id-list-menu-option-info-labels__title">
                            {{getName(userId)}}
                        </span>
                        <span class="st-staff-id-list-menu-option-info-labels__subtitle">
                            {{getUserInfo(userId)}}
                        </span>
                    </div>
                </div>
            </mat-list-option>
        </mat-selection-list>
    </form>
</mat-menu>